










export enum ConfigurableDataItemIds {

	SiteNumber = "SITE_NUMBER",

	SiteName = "SITE_NAME",

	SiteAddress = "SITE_ADDRESS",

	SiteCountry = "SITE_COUNTRY",

	SiteEmail = "SITE_EMAIL",

	SitePhone = "SITE_PHONE",

	SiteInvestigator = "SITE_INVESTIGATOR",

	SubjectId = "SUBJECT_ID",

	RandomizationNumber = "RANDOMIZATION_ID",

    RandomizationDate = "RANDOMIZATION_DATE",

	TerminationDate = "TERMINATION_DATE",

	SubjectDateOfBirth = "SUBJECT_DATE_OF_BIRTH",

	SubjectAge = "SUBJECT_AGE",

	SubjectGender = "SUBJECT_GENDER",

	SubjectHeight = "SUBJECT_HEIGHT",

	SubjectWeight = "SUBJECT_WEIGHT",

	SubjectBmi = "SUBJECT_BMI",

	SubjectPopulationGroup = "SUBJECT_POPULATION_GROUP",

	SubjectSmokerType = "SUBJECT_SMOKING_STATUS",

	SubjectLanguage = "SUBJECT_LANGUAGE",

    SubjectType = "SUBJECT_TYPE",

    BedTime = "BED_TIME"

}
